<template>
  <div>
    <p>
      Aquesta tarja serveix per a <strong>difondre diversos missatges breus</strong> o <strong>informació desglossada en diverses xifres o dades</strong>.
    </p>
    <p>
      Recomanem usar <strong>informació breu i directa</strong>, especialment xifres i dades.
    </p>
    <p>
      És pot afegir, si és adient, una foto de fons representativa, un hashtag relacionat amb la temàtica, així com el nom del col·lectiu al costat del logo.
    </p>
    <p>
      Aquest model de tarja accepta els següents formats:
    </p>
    <ul>
      <li><strong>1:1</strong>: model genèric per a compartir en la majoria de xarxes socials (Facebook, Instagram, canals de Telegram i Whatsapp, etc.).</li>
    </ul>

    <div class="help-examples">
      <img src="./examples/11.png" alt="Exemple 1:1" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'cards-help'
}
</script>
